// @flow
import * as React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';

import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import type { StreamConfigurationFormData, StreamConfigurationFormSection } from '../domain/StreamConfiguration';
import { INITIAL_DATA } from '../domain/StreamConfiguration';
import ActionBar from '../components/ActionBar';
import StreamingTechnologies from './streamConfigurationForm/StreamingTechnologies';
import StreamingTypes from './streamConfigurationForm/StreamingTypes';
import ActualStream from './streamConfigurationForm/ActualStream';

type Props = {
  t: any;
  theme?: Object;

  stepData: StreamConfigurationFormData;

  onNextStep: () => any;
  onSaveStep: (step: RadioConfigurationStep) => any;
}

type State = {
  data: StreamConfigurationFormData;
}

class StreamConfigurationForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { data: INITIAL_DATA };
  }

  componentWillMount() {
    this.setState({ data: this.props.stepData });
  }

  onChange = (key: string, value: StreamConfigurationFormSection) => {
    this.setState({
      data: {
        ...this.state.data,
        [key]: value,
      },
    });
  };

  onSubmit = (e: Event) => {
    e.preventDefault();
    const configuration = RadioConfigurationStep.of('STREAM', this.state.data);
    this.props.onSaveStep(configuration);
  }

  render() {
    const { t } = this.props;
    const { streamingTechnologies, streamTypes, currentStreamAndEquipment } = this.state.data;

    return (
      <form onSubmit={this.onSubmit}>
        <ActualStream onChange={v => this.onChange('currentStreamAndEquipment', v)} data={currentStreamAndEquipment} />
        <StreamingTechnologies onChange={v => this.onChange('streamingTechnologies', v)} data={streamingTechnologies} />
        <StreamingTypes onChange={v => this.onChange('streamTypes', v)} data={streamTypes} />
        <ActionBar onActionClick={this.props.onNextStep} actionText={t('next')}>
          <RaisedButton
            label={t('save')}
            primary
            type="submit"
          />
        </ActionBar>
      </form>
    );
  }
}

export default translate('radioConfiguration')(StreamConfigurationForm);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/StreamConfigurationForm.js